export default __webpack_public_path__ + "static/media/hospital-bed.f0fc6ad8.png";